var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modal-campaign",
        title: "Add Email Content",
        "hide-footer": "",
        size: "lg",
        centered: "",
      },
      on: { hidden: _vm.resetForm },
    },
    [
      _c("validation-observer", {
        ref: "observer",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var handleSubmit = ref.handleSubmit
              var invalid = ref.invalid
              return [
                _c(
                  "b-form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.validateAndSubmit)
                      },
                    },
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Post Name",
                                  "label-for": "campaign_name",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "campaign name",
                                    vid: "Campaign Name",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value: _vm.campaignName,
                                                callback: function ($$v) {
                                                  _vm.campaignName = $$v
                                                },
                                                expression: "campaignName",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Start Date",
                                  "label-for": "start_date",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "start date",
                                    vid: "Start Date",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-datepicker", {
                                              attrs: {
                                                id: "start_date",
                                                placeholder: "Choose a date",
                                                local: "en",
                                                min: _vm.currentDate,
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                                "initial-date": new Date(),
                                              },
                                              model: {
                                                value: _vm.startDate,
                                                callback: function ($$v) {
                                                  _vm.startDate = $$v
                                                },
                                                expression: "startDate",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "End Date",
                                  "label-for": "end_date",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "end date",
                                    vid: "End Date",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-datepicker", {
                                              attrs: {
                                                id: "end_date",
                                                placeholder: "Choose a date",
                                                local: "en",
                                                min:
                                                  _vm.startDate ||
                                                  _vm.currentDate,
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                                "initial-date": _vm.startDate,
                                              },
                                              model: {
                                                value: _vm.endDate,
                                                callback: function ($$v) {
                                                  _vm.endDate = $$v
                                                },
                                                expression: "endDate",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Template",
                                  "label-for": "email_template",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "email template",
                                    vid: "Email Template",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                options: _vm.templateOptions,
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              on: {
                                                change: _vm.selectTemplate,
                                              },
                                              model: {
                                                value: _vm.selectedTemplateId,
                                                callback: function ($$v) {
                                                  _vm.selectedTemplateId = $$v
                                                },
                                                expression:
                                                  "selectedTemplateId",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "SMTP Setting",
                                  "label-for": "email_smtp",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "SMTP setting",
                                    vid: "SMTP Setting",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                                options: _vm.smtp,
                                              },
                                              model: {
                                                value: _vm.selectedProvider,
                                                callback: function ($$v) {
                                                  _vm.selectedProvider = $$v
                                                },
                                                expression: "selectedProvider",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Segment",
                                  "label-for": "segment",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "segment",
                                    vid: "Segment",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("v-select", {
                                              staticClass:
                                                "item-selector-title",
                                              attrs: {
                                                options: _vm.segmentOptions,
                                                label: "itemTitle",
                                                multiple: "",
                                                clearable: false,
                                                placeholder: "Select Item",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value: _vm.selectedSegments,
                                                callback: function ($$v) {
                                                  _vm.selectedSegments = $$v
                                                },
                                                expression: "selectedSegments",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Subject",
                                  "label-for": "subject",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "subject",
                                    vid: "Subject",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                placeholder: "Subject",
                                                name: "subject",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value:
                                                  _vm.selectedTemplate.subject,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.selectedTemplate,
                                                    "subject",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "selectedTemplate.subject",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Content",
                                  "label-for": "email_content",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "email content",
                                    vid: "Email Content",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("quill-editor", {
                                              attrs: {
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value:
                                                  _vm.selectedTemplate.content,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.selectedTemplate,
                                                    "content",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "selectedTemplate.content",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: { label: "Budget", "label-for": "cost" },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required|numeric|min_value:1",
                                    name: "cost",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                type: "number",
                                                placeholder: "Enter Budget",
                                                name: "cost",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value: _vm.cost,
                                                callback: function ($$v) {
                                                  _vm.cost = $$v
                                                },
                                                expression: "cost",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      {
                        staticClass: "d-flex justify-content-end",
                        attrs: { md: "12" },
                      },
                      [
                        _c(
                          "b-button",
                          { attrs: { type: "submit", variant: "primary" } },
                          [_vm._v("SUBMIT")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }